import { useTranslation } from 'react-i18next';
import './MapToggleButton.css';

interface MapToggleButtonProps {
    isMapOpen: boolean;
    onClick: () => void;
    className?: string;
}

/**
 * MapToggleButton - Toggle button to show/hide the map drawer
 */
export default function MapToggleButton({ isMapOpen, onClick, className = '' }: MapToggleButtonProps) {
    const { t } = useTranslation();

    return (
        <button 
            className={`map-toggle-btn ${isMapOpen ? 'active' : ''} ${className}`}
            onClick={onClick}
            aria-expanded={isMapOpen}
            aria-label={isMapOpen ? t('trip.hide_map') : t('trip.show_map')}
        >
            <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
                <line x1="8" y1="2" x2="8" y2="18" />
                <line x1="16" y1="6" x2="16" y2="22" />
            </svg>
            <span>{isMapOpen ? t('trip.hide_map') : t('trip.show_map')}</span>
        </button>
    );
}
